import * as React from 'react'

import CircleIcon from '../../components/CircleIcon/CircleIcon'
import DividerComp from '../../components/DividerComp/DividerComp'
import Rectangle from '../../components/Rectangle/Rectangle'
import styles from './info-style.css'

type Props = {
  text: string
  icon?: string
  hideDivider?: boolean
}
type State = {}

class Info extends React.Component<Props, State> {
  static displayName = 'Info'
  static defaultProps = {}

  render() {
    const { text, icon, hideDivider } = this.props

    return (
      <div className={styles.info}>
        <CircleIcon icon={icon} className={styles.icon} />
        <Rectangle className={styles.rectangle}>{text}</Rectangle>
        {!hideDivider && <DividerComp />}
      </div>
    )
  }
}

export default Info